import { Plugin } from '@nuxt/types'

const ClientInit: Plugin = async (ctx) => {
  await ctx.store.dispatch('nuxtClientInit', ctx)
  await ctx.$accessor.app.SET_USER_INFO(ctx.$cookies.get('user'))
}

export default ClientInit
